import { render, staticRenderFns } from "./serveSections.vue?vue&type=template&id=5f11b47d&scoped=true&"
import script from "./serveSections.vue?vue&type=script&lang=js&"
export * from "./serveSections.vue?vue&type=script&lang=js&"
import style0 from "./serveSections.vue?vue&type=style&index=0&id=5f11b47d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11b47d",
  null
  
)

export default component.exports